<template>
  <div class="w-100">
    <v-card
      v-if="show === 'slot'"
      class="mx-auto entry-container m-0"
      elevation="11"
    >
      <v-card-title class="justify-content-center bg-tfsc">
        <v-row :class="mobile ? 'text-center justify-content-center' : ''">
          <v-col :cols="mobile ? '12' : '7'">
            <span :class="mobile ? 'text-h5 text-center' : 'text-h5'"
              >Booking</span
            >
          </v-col>
          <v-col>
            <v-row :class="mobile ? 'justify-center' : 'justify-end'">
              <v-btn
                v-if="Object.keys(query).length && query.duration"
                small
                color="grey"
                class="back-button"
                @click="$emit('setShow', 'cal')"
                >Back</v-btn
              >
              <v-btn
                v-if="
                  !query ||
                    !Object.keys(query).length ||
                    (Object.keys(query).length && !query.duration)
                "
                color="lightgrey"
                class="back-button"
                @click="$emit('setShowMakeBooking')"
                >{{
                  !showMakeABooking
                    ? "Show Availability Calendar"
                    : "Make A Booking"
                }}
                <v-icon
                  :id="
                    showMakeABooking
                      ? 'Show Availability Calendar'
                      : 'Make A Booking'
                  "
                  style="cursor: pointer;"
                  class="ml-2"
                  >{{ !showMakeABooking ? "event" : "note_alt" }}</v-icon
                >
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <hr />
      <div v-if="isLoading" class="text-center text-danger my-2">
          <v-progress-circular indeterminate />
        </div>
      <v-card-text>
        <v-row class="flex" align-v="start">
          <v-col cols="6">
            <v-row align-v="start">
              <v-col class="font-weight-bold">Date</v-col>
              <v-col class="pl-0 pr-0">
                <p>
                  {{ formatDate(apptData.slot_date, "DD/MM/YYYY") }}
                </p>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row align-v="start">
              <v-col class="font-weight-bold">Time</v-col>
              <v-col class="font-weight-bold">
                <p>{{ apptData.start_time }}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Finished HERE!!! TODO REMOVE COMMENT -->
        <v-row class="flex" align-v="start">
          <v-col :cols="mobile ? '12' : '3'" class="font-weight-bold"
            >Duration</v-col
          >
          <v-col :cols="mobile ? '12' : '3'" class="font-weight-bold">
            <v-select
              v-model="apptData.duration"
              :items="durationOptions"
            ></v-select>
          </v-col>
        </v-row>
        <!-- Finished HERE!!! TODO REMOVE COMMENT -->
        <v-row class="flex" align-v="start">
          <v-col :cols="mobile ? '12' : '3'" class="pt-3 font-weight-bold"
            >Facility</v-col
          >
          <v-col :cols="mobile ? '12' : '3'" class="pt-3 font-weight-bold">
            <v-select
              @change="onFacilitySubChange"
              v-model="apptData.facilitySubId"
              :items="facilityConfigOptions"
            ></v-select>
          </v-col>

          <v-col :cols="mobile ? '12' : '3'" class="pt-3 font-weight-bold"
            >Sport</v-col
          >
          <v-col :cols="mobile ? '12' : '3'" class="pt-3 font-weight-bold">
            <v-select
              v-model="apptData.facilitySport"
              :items="facilitySubOptions"
            ></v-select>
          </v-col>
        </v-row>

        <v-row class="flex" align-v="start">
          <v-col :cols="mobile ? '12' : '3'" class="p-4 font-weight-bold"
            >Additional Notes</v-col
          >
          <v-col :cols="mobile ? '12' : '9'" class="pt-3 font-weight-bold">
            <v-textarea
              outlined
              v-model="apptData.extNotes"
              type="text"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="12" v-if="bookingErrors.length">
            <b>Please correct the following error(s):</b>
            <ul>
              <li
                class="text-danger"
                v-bind:key="error.id"
                v-for="error in bookingErrors"
              >
                {{ error }}
              </li>
            </ul>
          </v-col>
        </v-row>
        <v-row class="justify-end">
          <v-btn small color="grey" class="m-3 mt-0" @click="validateForm"
            >Next</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>

    <AppointmentCustomer
      v-if="show === 'cust-info'"
      class="w-100"
      :apptData="apptData"
      :mobile="mobile"
      :errors="errors"
      :dataSuccess="dataSuccess"
      :notAvailable="notAvailable"
      :dataError="dataError"
      @setShow="passSetShow($event)"
      @onCancel="onCancel()"
      @onSubmit="onSubmit()"
    />

    <!-- Total Amount & Terms and Conditions -->
    <v-card
      v-if="show === 'pay' && apptData.totalAmount"
      class="p-4"
      elevation="11"
    >
      <v-card-title class="justify-content-center bg-tfsc">
        <v-row class="d-flex justify-center">
          <v-col :cols="mobile ? '8' : '9'">
            <span class="text-h5">Select Payment Options</span></v-col
          ><v-col>
            <v-row class="justify-end">
              <v-btn
                small
                color="grey"
                class="back-button"
                @click="$emit('setShow', 'slot')"
                >Back</v-btn
              >
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <v-row class="d-flex justify-center bespoke-margin">
        <h4 class="text-center">Total Amount</h4>
      </v-row>
      <v-row class="d-flex justify-center bespoke-margin">
        <h3 class="text-center">£{{ apptData.totalAmount }}</h3>
      </v-row>
      <v-row class="d-flex justify-center bespoke-margin">
        <v-col class="text-center p-4" cols="12">
          <div class="d-flex justify-center" fluid>
            <v-checkbox
              id="v-checkbox-booking"
              v-model="apptData.customer_data.tAndC"
              color="success"
              hide-details
            >
              <template v-slot:label>
                <p class="mb-0 mt-3">
                  I agree that I confirm that I have read and agree to the
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <b
                        style="cursor: pointer"
                        v-on="on"
                        @click="
                          e => {
                            e.preventDefault();
                            tAndCModal = !tAndCModal;
                          }
                        "
                        @click.stop
                        >Terms and Conditions</b
                      >
                    </template>
                    Open Terms And Conditions
                  </v-tooltip>
                  for this facility.
                </p>
              </template>
            </v-checkbox>
          </div>
        </v-col>
      </v-row>
      <hr />
      <v-row class="justify-end bespoke-margin">
        <v-btn small color="grey" class="m-3" @click="passSetShow('cust-info')"
          >Next
        </v-btn>
      </v-row>
      <v-row class="justify-center bespoke-margin">
        <v-alert
          :icon="false"
          v-if="validateTAndC"
          class="text-center bespoke-margin"
          color="red"
          dark
          type="error"
          dense
          outlined
          >You can only proceed if you have accepted the Terms And Conditions.
        </v-alert>
      </v-row>

      <TermsAndConditions
        v-if="tAndCModal"
        ref="TermsAndConditions"
        :termsCopy="facilityData.termsCopy ? facilityData.termsCopy : ''"
        :tAndCModal="tAndCModal"
        @hideDialog="hideDialog"
      />
    </v-card>
    <!-- Total Amount & Terms and Conditions -->
    <v-card v-if="show === 'paying'" class="p-4" elevation="11">
      <v-card-title class="d-flex justify-center bg-tfsc">
        <v-row>
          <v-col cols="12">
            <span class="text-h5">Payment In Process</span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-row class="d-flex mt-3 mr-0 w-100 justify-center bespoke-margin">
        <h4 class="text-center">Total Amount</h4>
      </v-row>
      <v-row class="d-flex mt-3 mr-0 w-100 justify-center bespoke-margin">
        <h5 class="text-center">£{{ apptData.totalAmount }}</h5>
      </v-row>
      <v-row class="d-flex mt-3 mr-0 w-100 justify-center bespoke-margin">
        <p class="text-center">
          If your booking has been successful, you will recieve a booking
          confirmation email shortly
        </p>
        <p v-if="paymentRedirectUrl !== ''">If you are not redirected please click <a :href="paymentRedirectUrl" target="_blank">here</a> to make payment.</p>
      </v-row>
      <hr />
    </v-card>
  </div>
</template>

<script>
import {
  getAppt,
  fetchFacility,
  updateAppt,
  getFacilityPrice,
  createPaymentLink,
  saveAppt
} from "../services/FacilityService.js";
import AppointmentCustomer from "@/components/Appointment/Customer/index.vue";
import TermsAndConditions from "@/components/Modals/TermsAndConditions/index.vue";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  components: {
    AppointmentCustomer,
    TermsAndConditions
  },
  props: {
    query: { type: Object, required: true },
    show: { type: String },
    showMakeABooking: { type: Boolean }
  },
  data() {
    return {
      meta: {
        loaded: true,
        title: "TFSC Reservation"
      },
      errors: [],
      bookingErrors: [],
      validateTAndC: false,
      tAndCModal: false,
      price: 0,
      isLoading: false,
      facilityData: [],
      timeDif: "",
      dataSuccess: false,
      notAvailable: "",
      dataError: false,
      dataErrorMessage: "",
      duration: 0,
      nextSlot: "",
      originalSlot: null,
      nextSlotId: "",
      durationOptions: [
        { text: "Select An Option", value: 0 },
        { text: "1 Hour", value: 60 },
        { text: "1 Hour 30 Mins", value: 90 },
        { text: "2 hours", value: 120 },
        { text: "2 Hours 30 Mins", value: 150 },
        { text: "3 Hours", value: 180 },
        { text: "3 Hours 30 Mins", value: 210 },
        { text: "4 Hours", value: 240 },
        { text: "4 Hour 30 Mins", value: 270 },
        { text: "5 hours", value: 300 },
        { text: "5 Hours 30 Mins", value: 330 },
        { text: "6 Hours", value: 360 },
        { text: "6 Hours 30 Mins", value: 390 },
        { text: "7 Hours", value: 420 },
        { text: "7 Hours 30 Mins", value: 450 },
        { text: "8 Hours", value: 480 },
        { text: "8 Hour 30 Mins", value: 510 },
        { text: "9 hours", value: 540 },
        { text: "9 Hours 30 Mins", value: 570 },
        { text: "10 Hours", value: 600 },
        { text: "10 Hours 30 Mins", value: 630 },
        { text: "11 Hours", value: 660 },
        { text: "11 Hours 30 Mins", value: 690 },
        { text: "12 Hours", value: 720 }
      ],
      extend_duration: false,
      facilitySubOptions: [],
      listOfIds: [],
      facilityConfigOptions: [],
      facilitySearchSize: "",
      apptData: {
        facilitySubId: "",
        facilitySize: "",
        facilityName: "",
        emails: {
          customer_initial_email: {},
          tf_initial_email: {},
          customer_booked_email: {},
          customer_warning_email: {}
        },
        intNotes: "",
        extNotes: "",
        customer_data: {}
      },
      mobile: window.innerWidth <= 1200,
      paymentRedirectUrl: "",
      person: {},
      statusOptions: ["Available", "Pending", "Booked", "Hold"]
    };
  },
  created() {
    addEventListener("resize", () => {
      this.mobile = window.innerWidth <= 1200;
    });
  },
  computed: {
    ...mapGetters(["user"])
  },
  watch: {
    ["apptData.facilitySubId"]() {
      if (this.apptData.duration && this.apptData.facilitySubId)
        this.getFacilityPrice();
    },
    ["apptData.duration"]() {
      if (this.apptData.duration && this.apptData.facilitySubId)
        this.getFacilityPrice();
    }
  },
  mounted() {
    setTimeout(async () => {
      await this.getAppt();
      await this.getFacility();
    }, 100);
  },
  methods: {
    async getFacilityPrice() {
      const bookingData = {
        facilitySubId: this.apptData.facilitySubId,
        duration: this.apptData.duration,
        startDate: new Date(
          `${this.apptData.slot_date} ${this.apptData.start_time}`
        ),
        endDate: this.apptData.end_time
      };
      let priceRes = await getFacilityPrice(
        this.apptData.facilityId,
        bookingData
      );
      this.apptData.totalAmount = priceRes.data.price;
      this.price = priceRes.data.price;
    },
    async makePayment() {
      const stripePayload = {
        currency: "gbp",
        unit_amount: this.apptData.totalAmount * 100,
        product: this.apptData.facilityId,
        successUrl: `${window.location.origin}/booking/platform#/facility/slot/success/${this.query.id}`
      };
      let res = await createPaymentLink(stripePayload);
      this.paymentRedirectUrl = res.data.url;
      this.apptData.transactionLink = res.data.url;
      this.apptData.stripePayload = JSON.stringify(stripePayload);
      let updateRes = await updateAppt({ data: this.apptData, ext: true });
      if (updateRes.status && updateRes.status <= 399) {
        this.passSetShow("paying");
        window.location.href = res.data.url
      } else {
        this.dataError = true;
        if (res.error) {
          this.dataErrorMessage = res.Message;
        }
      }
    },
    extend_duration_handler() {
      if (this.extend_duration == true) {
        this.extend_duration = false;
      } else {
        this.extend_duration = true;
      }
    },
    async getFacility() {
      let res = await fetchFacility(this.apptData.facilityId);
      if (res && res.data) {
        this.facilityData = res.data[0];
        this.facilityConfigOptions = res.data[0].facilityConfigurations.map(
          config => {
            return {
              text: config.title,
              value: config.facilitySubId
            };
          }
        );
        this.facilitySubOptions = res.data[0].facilitySportOptions.map(
          subCategory => {
            return {
              text: subCategory,
              value: subCategory
            };
          }
        );
        // Default the initial values to the first value in array
        let defObj = {
          text: "Select An Option",
          value: ""
        };
        this.facilityConfigOptions = [defObj].concat(
          this.facilityConfigOptions
        );
        this.facilitySubOptions = [defObj].concat(this.facilitySubOptions);
        this.onFacilitySubChange();
      }
    },
    async getAppt() {
      this.isLoading = true
      let res = await getAppt(this.query.id);
      if (res.error) {
        this.text = "An internal server error occurred. Please try later.";
      }
      this.apptData = {...res};
      this.originalSlot = {...res}
      if (!this.apptData.customer_data) {
        this.apptData.customer_data = {
          email: ""
        };
      }
      this.timeDif = moment({...this.apptData}.end_time).diff(
        moment({...this.apptData}.start_time),
        "minutes"
      );

      this.apptData.slot_date = moment({...this.apptData}.slot_date).format(
        "YYYY-MM-DD"
      );
      const date = new Date(this.apptData.start_time); // Example date
      const time = date.toISOString().substring(11, 16); // Extract time (HH:mm:ss)
      this.apptData.start_time = time
      if (this.query.duration) {
        this.apptData.duration = Number(this.query.duration);
      }
      if (this.query.facilitySport) {
        this.apptData.facilitySport = this.query.facilitySport;
      }
      if (this.query.status) {
        this.apptData.status = this.query.status;
      }
      this.apptData.transactionType = "ExtCard";
      this.isLoading = false
    },
    async onSubmit() {
      this.notAvailable = "";
      this.dataSuccess = false;
      this.dataError = false;
      this.errors = [];
      let end_time = moment({ ...this.originalSlot }.start_time)
        .clone()
        .add(this.apptData.duration, 'minutes')
        .format('DD-MMM-YYYY kk:mm')

      this.apptData.end_time = end_time

      let start_time = moment({...this.originalSlot}.start_time)
        .format("DD-MMM-YYYY kk:mm");
      const tmpStartTime = this.dateWithoutTimezone(new Date(start_time));
      const tmpEndTime = this.dateWithoutTimezone(new Date(end_time));
      this.originalEndTime = tmpEndTime;
      this.apptData.start_time = {...this.originalSlot}.start_time
      delete this.apptData.slot_date 
      if (
        !this.apptData.audit ||
        (this.apptData.audit && this.apptData.audit.length === 0)
      ) {
        this.apptData.audit = [];
      }
      this.apptData.audit.push({
        updatedDate: new Date(),
        updatedBy: "Ext User"
      });

      if (!this.apptData.customer_data.email) {
        this.errors.push("Please enter a valid Email Address.");
      }
      if (!this.apptData.customer_data.name) {
        this.errors.push("Please enter a valid Name.");
      }
      if (!this.apptData.customer_data.phone_number) {
        this.errors.push("Please enter a valid Telephone Number.");
      }
      if (!this.apptData.customer_data.tAndC) {
        this.errors.push(
          "You can only proceed if you have accepted the Terms And Conditions."
        );
      }
      if (!this.apptData.customer_data.occupancy) {
        this.errors.push("Please enter a valid Occupancy");
      }
      if (!this.apptData.duration) {
        this.errors.push("Please enter a valid Duration");
      }
      if (!this.apptData.facilitySport) {
        this.errors.push("Please enter a valid Sport Option");
      }
      if (!this.apptData.facilityName) {
        this.errors.push("Please enter a valid Facility Configuration");
      }
      if (!this.apptData.totalAmount) {
        this.errors.push("Please enter a valid Total Amount");
      }
      if (this.errors.length >= 1) {
        return;
      }
      this.apptData.customer_data.tAndCCopy = this.facilityData.termsCopy;
      this.apptData.status = "Hold";
      this.apptData.transactionStatus = "awaiting";

      let res = await saveAppt({
        searchEnd: tmpEndTime,
        searchStart: tmpStartTime,
        facilityId: this.apptData.facilityId,
        status: this.apptData.status,
        data: this.apptData
      });
      if (res.status && res.status <= 399) {
        if (res.data.msg) {
          this.apptData.transactionLink = "";
          this.apptData.transactionStatus = "";
          this.apptData.transactionId = "";
          this.notAvailable = res.data.msg;
        } else {
          this.makePayment();
        }
      } else {
        this.dataError = true;
        if (res.error) {
          this.dataErrorMessage = res.Message;
        }
      }
    },
    dateWithoutTimezone(date) {
      const tzoffset = date.getTimezoneOffset() * 60000; //offset in milliseconds
      const withoutTimezone = new Date(date.valueOf() - tzoffset)
        .toISOString()
        .slice(0, -1);
      return withoutTimezone;
    },
    onCancel() {
      this.$emit("setShow", "form");
    },
    formatDate(_val, formatType) {
      if (_val) {
        return moment(String(_val)).format(formatType);
      }
    },
    onFacilitySubChange() {
      this.facilityData.facilityConfigurations.forEach(config => {
        if (config.facilitySubId === this.apptData.facilitySubId) {
          this.facilitySearchSize = config.facilitySize;
          this.apptData.facilitySize = config.facilitySize;
          this.apptData.facilityName = config.title;
        }
      });
    },
    setListOfIds(list) {
      this.listOfIds = list;
    },
    passSetShow(type) {
      this.validateTAndC = false;
      if (type === "cust-info" && !this.apptData.customer_data.tAndC) {
        this.validateTAndC = true;
        setTimeout(() => {
          this.validateTAndC = false;
        }, 6000);
        return;
      }
      this.$emit("setShow", type);
    },
    validateForm() {
      this.bookingErrors = [];
      if (!this.apptData.duration) {
        this.bookingErrors.push("Please enter a valid Duration");
      }
      if (!this.apptData.facilitySport) {
        this.bookingErrors.push("Please enter a valid Sport Option");
      }
      if (!this.apptData.facilitySubId) {
        this.bookingErrors.push("Please enter a valid Facility");
      }

      if (this.bookingErrors.length >= 1) {
        return;
      } else {
        this.$emit("setShow", "pay");
      }
    },
    hideDialog() {
      this.tAndCModal = !this.tAndCModal;
    }
  }
};
</script>
<style>
label {
  min-width: 80px;
}

#input-link {
  min-width: 52%;
}

#checkout-button {
  height: 36px;
  margin-top: 10px;
  background: #556cd6;
  border-radius: 0 0 4px 4px;
  color: #fff;
  border: 0;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
}
.text-danger {
  color: red !important;
}
#v-checkbox-booking {
  background-color: green;
  opacity: 1;
}
</style>
